import { createFileRoute } from '@tanstack/react-router'

import DetailSubmissionPage from '@/components/pages/backoffice/_klb-petani/_poktan/_$poktanId/kelas-kemampuan/submission/_$verificationId/container/DetailSubmissionPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId/'
)({
  component: DetailSubmissionPage
})
